import { APIClient } from '@frontend/api-utils';
import { UserRemoteLogin } from '@frontend/user/types';

export class UserDeviceClient extends APIClient {
    public static readonly endpoint = '/user-api/v1';

    public static async postIdentifyDevice(accountId: string, userId: string, body: UserRemoteLogin): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/users/${userId}/identify-device`, body);
        return await this.handleVoidResponse(response);
    }
}
